import emma from '@/common/services/Emma'

const InvestmentResource = {
	getClientInvestmentProducts (userId) { return emma.get('api/investment-product?user_id=' + userId) },
	getInvestmentProduct (id) { return emma.get('api/investment-product/' + id) },
	getCountriesInvestmentProducts (userId) { return emma.get(`api/clients/${userId}/countries-placement`) },
	updateInvestmentProduct (id, data) { return emma.post('api/investment-product/' + id, data) },
	addInvestmentProduct (userId, data) { return emma.post('api/investment-product?user_id=' + userId, data) },
	deleteInvestmentProducts (id) { return emma.post('api/investment-product/' + id + '/delete') }
}

export default InvestmentResource



// WEBPACK FOOTER //
// ./src/common/resources/investment.js